import { render, staticRenderFns } from "./authorWrite.vue?vue&type=template&id=bee354a2&scoped=true&"
import script from "./authorWrite.vue?vue&type=script&lang=js&"
export * from "./authorWrite.vue?vue&type=script&lang=js&"
import style0 from "./authorWrite.vue?vue&type=style&index=0&lang=css&"
import style1 from "./authorWrite.vue?vue&type=style&index=1&id=bee354a2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee354a2",
  null
  
)

export default component.exports